import React, { useEffect, useState } from "react";
import OutgoingLayout from "./OutgoingLayout";
import { GetAccess } from "../../../../Components/Utils/roles";
import DeleteIcon from "../../../../Components/Icons/Delete";
import {
  CancelButton,
  CreateButton,
} from "../../../../Components/Utils/Buttons";
import NuDate from "../../../../Components/Utils/NuDate";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import { Link, useLocation, useParams } from "react-router-dom";
import ViewIcon from "../../../../Components/Icons/ViewIcon";
import axiosInstance from "../../../../Services/axiosCommon";
import MobilePaymentIndex from "../../../Mobile/Invoice/Outgoing/MobilePaymentIndex";
import NuAmount from "../../../../Components/Utils/NuAmount";
import CloseIcon from "../../../../Components/Icons/Close";

function PaymtHistory() {
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const { invoiceOutgoingViewId } = useParams();
  const location = useLocation();

  const Data = location?.state?.data;
  const [data, setData] = useState(location.state?.data || []);

  const [showCreate, setShowCreate] = useState(false);
  const [showHistory, setShowHistory] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const confirmDelete = (id) => {
    setDeleteId(id);
    setIsOpen(true);
  };

  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getPayableView = () => {
    axiosInstance
      .get(`/invoices-outgoing/${invoiceOutgoingViewId}`)
      .then((res) => {
        setData(res?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (!Data) {
      getPayableView();
    }
  }, []);

  const handleDelete = async () => {
    if (deleteId) {
      try {
        await axiosInstance.delete(
          `/invoices-outgoing/delete-payment/${deleteId}`
        );
        getPayableView();
      } catch (error) {
        console.error("Error deleting:", error);
      } finally {
        setIsOpen(false);
        setDeleteId(null);
      }
    }
  };

  const [params, setParams] = useState({
    //  page: page,
    //  per_page: pageCount,
    //  search:searchQuery||"",
  });
  // const { getData,dataLoading } = UseGetDataSearch( `/invoices-outgoing/${invoiceOutgoingViewId}`,params);

  return (
    <OutgoingLayout
      // EditAccess={GetAccess("customer_quote_create")}
      BackAccess={GetAccess("customer_quote_create")}
      isPaymentHistory={true}
      paidAmount={data?.receivedAmount||0}
      balAmount={data?.balanceAmount||0}
      totalAmount={data?.totalAmount||0}
      totalLength={data?.paymentsHistory?.length||0}
    >
      {screenSize.width < "768" ? (
        <>
          <div className=" w-full h-[calc(100vh-160px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden">
            <MobilePaymentIndex
              data={data?.paymentsHistory || []}
              getData={getPayableView}
            />
          </div>
        </>
      ) : (
        <>
          <div className="overflow-x-auto mt-0.5 rounded-md bg-white h-[calc(100vh-160px)]">
            <table className="min-w-full text-xs text-left">
              <thead>
                <tr className="text-black font-semibold border-b border-gray-300">
                  {/* <th className="px-4 py-2">SNo.</th> */}
                  <th className="px-4 py-2">Received On</th>
                  <th className="px-4 py-2">Received Amount</th>
                  <th className="px-4 py-2">Bal. Amount</th>

                  <th className="px-4 py-2">Paymt. Method</th>
                  {/* <th className="px-4 py-2">Comments</th> */}
                  <th className="px-4 py-2">Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.paymentsHistory?.map((List, index) => (
                  <tr
                    key={index}
                    className=" hover:bg-gray-50 rounded-md shadow-sm"
                  >
                    {/* <td className="px-4 py-2">

                      {data?.paymentsHistory?.length - index}

                    </td> */}
                    <td className="px-4 py-2">
                      {List?.receivedOn ? (
                        <NuDate
                          value={List.receivedOn}
                          format="DD-MMM-YYYY HH:mm"
                        />
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td className="px-4 py-2 ">
                      <NuAmount value={List?.receivedAmount} />
                    </td>

                    <td className="px-4 py-2 ">
                      <NuAmount value={List?.balanceAmount} />
                    </td>

                    <td className="px-4 py-2">{List?.paymentMethod}</td>
                    {/* <td className="px-4 py-2">
                      {List?.comments}
                    </td> */}
                    <td className="px-4 py-2">
                    <button
                        onClick={() => {
                          setSelectedPayment(List);
                          setShowViewModal(true);
                        }}
                        className="text-baseColor-primary ml-2 "
                      >
                        <ViewIcon />
                      </button>
                      <button
                        onClick={() => confirmDelete(List?.id)}
                        className="text-yellow-500 ml-2"
                      >
                        <DeleteIcon />
                      </button>
                     
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {isOpen && (
              <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
                <div open={isOpen} onClose={() => setIsOpen(false)}>
                  <div className="animate-scale-in w-72  max-h-[99vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
                    <h2 className="text-sm font-semibold">
                      Are you sure! You want to Delete?
                    </h2>
                    {/* <p className="text-gray-600 mt-2">Do you really want to delete this data? This action cannot be undone.</p> */}
                    <div className="mt-4 flex justify-end space-x-2">
                      <button
                        onClick={() => setIsOpen(false)}
                        className="px-3 py-[9px] cursor-pointer text-xs 2xl:text-sm  text-textColor-main bg-[#E6F2F2] hover:bg-gray-300
      rounded-md flex items-center"
                      >
                        No
                      </button>
                      <button
                        onClick={handleDelete}
                        className="bg-textColor-main px-3 py-[9px] cursor-pointer  outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center mr-3"
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              // </div>
            )}
            {showViewModal && selectedPayment && (
              <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
                <div className="animate-scale-in w-auto  bg-white py-6 px-8 rounded-md shadow-lg overflow-y-auto h-auto relative">
                  <div className="flex justify-between ">
                    <h2 className="text-base font-semibold mb-2 ">
                      Payment Details
                    </h2>
                    <button onClick={() => setShowViewModal(false)}>
                      <CloseIcon />
                    </button>
                  </div>
                  <table className=" w-full border-collapse text-xs 2xl:text-sm text-left">
                    <tr>
                      <td className="px-4 py-2">
                        <strong>Received On</strong>
                      </td>
                      <td className="px-4 py-2">
                        <p>
                          {" "}
                         : {selectedPayment.receivedOn ? (
                            <NuDate
                              value={selectedPayment.receivedOn}
                              format="DD-MMM-YYYY HH:mm"
                            />
                          ) : (
                            "N/A"
                          )}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-4 py-2">
                        {" "}
                        <strong>Received Amount</strong>
                      </td>
                      <td  className="px-4 py-2">
                        {" "}
                        <p>
                          {" "}
                          : <NuAmount value={selectedPayment.receivedAmount} />
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-4 py-2">
                        <strong>Balance Amount</strong>
                      </td>
                      <td className="px-4 py-2">
                        <p>
                          {" "}
                          : <NuAmount value={selectedPayment.balanceAmount} />
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-4 py-2">
                        <strong>Total Amount</strong>
                      </td>
                      <td className="px-4 py-2">
                        <p>
                          {" "}
                          : <NuAmount value={data.totalAmount} />
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-4 py-2">
                        <strong>Payment Method</strong>
                      </td>
                      <td className="px-4 py-2">
                        <p> : {selectedPayment.paymentMethod || "-"}</p>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-4 py-2">
                        <strong>Comments</strong>
                      </td>
                      <td className="px-4 py-2">
                        <p>: {selectedPayment.comments || "-"}</p>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </OutgoingLayout>
  );
}

export default PaymtHistory;
